
























import mixins from 'vue-typed-mixins'
import Employees from '@/builder/sections/section/employees/mixins/Employees'
import EmployeeCard from '@/builder/sections/section/employees/components/EmployeeCard.vue'
export default mixins(Employees).extend({
  name: 'Employees6',
  components: { EmployeeCard }
})
